export interface NavigationRoleState {
  ownerId: string | null;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  userRole: string;
}

export const EMPTY_NAVIGATION_ROLE_STATE: NavigationRoleState = {
  ownerId: null,
  isAdmin: false,
  isSuperAdmin: false,
  userRole: '',
};

/**
 * Role-derived controls fail closed during the render in which auth identity
 * changes; effects are intentionally not relied upon to clear the prior user.
 */
export function getVisibleNavigationRoleState(
  state: NavigationRoleState,
  currentUserId: string | null,
): NavigationRoleState {
  if (!currentUserId || state.ownerId !== currentUserId) {
    return EMPTY_NAVIGATION_ROLE_STATE;
  }
  return state;
}
